import {Map, OrderedMap} from 'immutable';

import {
  ADD_ERROR,
  REMOVE_ERROR,
  RESET_ERRORS
} from './actions';

export const initialState = new Map({
  errors: new OrderedMap(),
  hasError: false
});


export default function reducer(state = initialState, action) {
  switch (action.type) {
    case ADD_ERROR: {
      const {error} = action.payload;

      return state.setIn(['errors', error.id], error)
        .set('hasError', true);
    }
    case REMOVE_ERROR: {
      const {errorId} = action.payload;
      const updatedState = state.deleteIn(['errors', errorId]);

      if (updatedState.get('errors').size === 0) {
        return updatedState.set('hasError', false);
      }

      return updatedState;
    }
    case RESET_ERRORS: {
      return initialState;
    }
    default:
      return state;
  }
}
